import { Object3D } from "./object3d";
export class Group extends Object3D {
    constructor(objects = []) {
        super();
        this.setObjects(objects);
    }
    setObjects(objects) {
        this.objects = objects;
    }
    addObject(object) {
        this.objects.push(object);
    }
    setCentroid(vector) {
        this.centroid = vector;
    }
}
